import React, { ReactNode } from "react";
import { ChevronLeft, X } from "lucide-react";
import MGProgressBar from "../../../components/MGProgressBar/MGProgressBar";
import styles from "./MGPageToolbar.module.css";

export type TMGPageToolbarProps = {
  title: string;
  dataTestId?: string;
  isFixed?: boolean;
  fixedMode?: "internal" | "document";
  style?: React.CSSProperties;
  titleAlign?: "left" | "center" | "right";
  currentStep?: number;
  totalSteps?: number;
  progressHeight?: number;
  onBack?: () => void;
  onClose?: () => void;
  rightAction?: {
    ariaLabel: string;
    disabled?: boolean;
    icon: ReactNode;
    onClick: () => void;
    title?: string;
  };
};

export const MGPageToolbar = ({
  title,
  dataTestId,
  isFixed = true,
  fixedMode = "internal",
  style,
  titleAlign = "center",
  currentStep,
  totalSteps,
  progressHeight = 4,
  onBack,
  onClose,
  rightAction,
}: TMGPageToolbarProps) => {
  const shouldShowProgress = currentStep !== undefined && totalSteps !== undefined;
  const fixedClassName = fixedMode === "document" ? styles.fixedDocument : styles.fixedInternal;
  const toolbarClassName = `${styles.toolbar} ${isFixed ? fixedClassName : ""}`;
  const titleAlignClassName = {
    left: styles.titleAlignLeft,
    center: styles.titleAlignCenter,
    right: styles.titleAlignRight,
  }[titleAlign];
  const titleClassName = `${styles.title} ${titleAlignClassName}`;

  return (
    <div className={toolbarClassName} data-testid={dataTestId} style={style}>
      <div className={styles.content}>
        {onBack ? (
          <button
            className={styles.iconButton}
            type="button"
            aria-label="Voltar"
            data-testid={dataTestId && `${dataTestId}-back-button`}
            onClick={onBack}>
            <ChevronLeft size={24} />
          </button>
        ) : (
          <span className={styles.iconSlot} aria-hidden="true" />
        )}

        <span className={titleClassName} data-testid={dataTestId && `${dataTestId}-title`}>
          {title}
        </span>

        {rightAction ? (
          <button
            className={styles.iconButton}
            type="button"
            aria-label={rightAction.ariaLabel}
            title={rightAction.title || rightAction.ariaLabel}
            disabled={rightAction.disabled}
            data-testid={dataTestId && `${dataTestId}-right-action`}
            onClick={rightAction.onClick}>
            {rightAction.icon}
          </button>
        ) : onClose ? (
          <button
            className={styles.iconButton}
            type="button"
            aria-label="Fechar"
            data-testid={dataTestId && `${dataTestId}-close-button`}
            onClick={onClose}>
            <X size={24} />
          </button>
        ) : (
          <span className={styles.iconSlot} aria-hidden="true" />
        )}
      </div>

      {shouldShowProgress && (
        <MGProgressBar currentStep={currentStep} totalSteps={totalSteps} height={progressHeight} />
      )}
    </div>
  );
};
